import React from 'react';
import tw from "twin.macro";
import styled from 'styled-components';
import { IoBagHandle, IoPieChart, IoPeople, IoCart } from 'react-icons/io5';

const GridContainer = styled.div`
  ${tw`flex flex-wrap gap-4`}
`;

const BoxWrapper = styled.div`
  ${tw`bg-white rounded-sm p-4 flex-1 border border-gray-200 flex items-center`}
  min-width: 200px; /* Minimum width for each box */
  flex-basis: calc(25% - 1rem); /* Adjust based on number of columns */
`;

const IconWrapper = styled.div`
  ${tw`rounded-full h-12 w-12 flex items-center justify-center`}
`;

const Title = styled.span`
  ${tw`text-sm text-gray-500 font-light`}
`;

const Value = styled.strong`
  ${tw`text-xl text-gray-700 font-semibold`}
`;

const Change = styled.span`
  ${tw`text-sm pl-2`}
`;

export default function DashboardStatsGrid() {
  return (
    <GridContainer>
      <BoxWrapper>
        <IconWrapper className="bg-sky-500">
          <IoBagHandle className="text-2xl text-white" />
        </IconWrapper>
        <div className="pl-4">
          <Title>Total Sales</Title>
          <div className="flex items-center">
            <Value>$54232</Value>
            <Change className="text-green-500">+343</Change>
          </div>
        </div>
      </BoxWrapper>
      <BoxWrapper>
        <IconWrapper className="bg-orange-600">
          <IoPieChart className="text-2xl text-white" />
        </IconWrapper>
        <div className="pl-4">
          <Title>Total Expenses</Title>
          <div className="flex items-center">
            <Value>$3423</Value>
            <Change className="text-green-500">-343</Change>
          </div>
        </div>
      </BoxWrapper>
      <BoxWrapper>
        <IconWrapper className="bg-yellow-400">
          <IoPeople className="text-2xl text-white" />
        </IconWrapper>
        <div className="pl-4">
          <Title>Total Customers</Title>
          <div className="flex items-center">
            <Value>12313</Value>
            <Change className="text-red-500">-30</Change>
          </div>
        </div>
      </BoxWrapper>
      <BoxWrapper>
        <IconWrapper className="bg-green-600">
          <IoCart className="text-2xl text-white" />
        </IconWrapper>
        <div className="pl-4">
          <Title>Total Orders</Title>
          <div className="flex items-center">
            <Value>16432</Value>
            <Change className="text-red-500">-43</Change>
          </div>
        </div>
      </BoxWrapper>
    </GridContainer>
  );
}
